import React from "react";
import { ITenant } from "components/tenants/types";

interface ContactPersonTabProps {
  tenant: ITenant;
  onEdit: () => void;
}

const ContactPersonTab: React.FC<ContactPersonTabProps> = ({ tenant, onEdit }) => {
  const contact = tenant.contactPerson;

  return (
    <div className="p-3 border rounded shadow-sm bg-white">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">Contact Person</h5>
        <button type="button" className="btn btn-sm btn-primary" onClick={onEdit}>
          Edit
        </button>
      </div>

      <div className="row gy-3">
        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">First Name:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          <p className="mb-0">{contact?.firstName || "-"}</p>
        </div>

        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">Last Name:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          <p className="mb-0">{contact?.lastName || "-"}</p>
        </div>

        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">Job Title:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          <p className="mb-0">{contact?.jobTitle || "-"}</p>
        </div>

        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">Email:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          {contact?.email ? (
            <a
              className="btn btn-link text-lowercase mb-0 p-0"
              href={`mailto:${contact.email}`}
              target="_blank"
              rel="noreferrer"
            >
              {contact.email}
            </a>
          ) : (
            <p className="mb-0">-</p>
          )}
        </div>

        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">Office Number:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          {contact?.phone ? (
            <a className="btn btn-link mb-0 p-0" href={`tel:${contact.phone}`}>
              {contact.phone}
            </a>
          ) : (
            <p className="mb-0">-</p>
          )}
        </div>

        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">Extension Number:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          <p className="mb-0">{contact?.phoneExtension || "-"}</p>
        </div>

        <div className="col-5 col-lg-2">
          <p className="fw-bold mb-0">Mobile Number:</p>
        </div>
        <div className="col-7 col-lg-10 text-lg-start text-end">
          {contact?.mobilePhone ? (
            <a className="btn btn-link mb-0 p-0" href={`tel:${contact.mobilePhone}`}>
              {contact.mobilePhone}
            </a>
          ) : (
            <p className="mb-0">-</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPersonTab;
